export const Loader = ({ full }) => (
  <div data-testid="loader" className={`flex flex-col items-center justify-center gap-4 ${full ? "min-h-screen" : "py-16"}`}>
    {full && <img src="/brand/monogram-oro.png" alt="Skin Lovers Professional" className="h-10 w-auto animate-pulse" />}
    <span className="w-16 h-[2px] rounded-full bg-gold origin-center animate-loader-bar shadow-[0_0_12px_rgba(212,175,55,0.8)]" />
  </div>
);

export const EmptyState = ({ title, text, children, testid = "empty-state" }) => (
  <div data-testid={testid} className="lux-card px-6 py-14 text-center animate-fade-up">
    <span className="mx-auto mb-5 block w-10 h-10 rounded-full border border-gold/30 bg-gold/10 shadow-[0_0_24px_-6px_rgba(212,175,55,0.6)]" />
    <p className="font-serif text-2xl">{title}</p>
    {text && <p className="mt-2 text-sm text-warm-text max-w-sm mx-auto leading-relaxed">{text}</p>}
    {children && <div className="mt-6">{children}</div>}
  </div>
);

export const PageHeader = ({ eyebrow, title, subtitle, actions }) => (
  <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between mb-8 sm:mb-12 animate-fade-up">
    <div>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h1 data-testid="page-title" className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05]">{title}</h1>
      <div className="gold-line w-24 mt-5" />
      {subtitle && <p className="mt-4 text-sm sm:text-base text-warm-text max-w-xl leading-relaxed">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
  </div>
);
